import { useContext } from 'react';
import { FieldContext } from './use-field-context.props';

const useFieldContext = () => {
  return useContext(FieldContext);
};

export { useFieldContext };
